import { Box, Flex, forwardRef, ListItem, ListItemProps, Text } from '@chakra-ui/react';
import { dataAttr } from '@chakra-ui/utils';

import { IAlgoliaFilterItem } from '@/interfaces/IAlgoliaFilterItem';

interface IComboboxProps extends ListItemProps {
  item: IAlgoliaFilterItem;
  isHighlighted: boolean;
}

const formattedSubjectData = (filterItem: IAlgoliaFilterItem) => {
  if (!filterItem) return;
  const { label } = filterItem;

  const subjectcategoriesarray = label?.split('/');
  const lastsubject = subjectcategoriesarray?.pop();

  return { title: lastsubject, subtitle: subjectcategoriesarray.join('/') };
};

export const FilterComboboxItem = forwardRef<IComboboxProps, 'li'>(({ isHighlighted, item, ...rest }, ref) => {
  const { title, subtitle } = formattedSubjectData(item);

  return (
    <ListItem
      fontSize="md"
      fontWeight="semibold"
      lineHeight="short"
      transition="background-color 220ms, color 220ms"
      _hover={{
        color: 'violet.400',
        bg: 'gray.50',
      }}
      data-highlighted={dataAttr(isHighlighted)}
      _highlighted={{
        bg: 'gray.100',
      }}
      py={3}
      cursor="pointer"
      {...rest}
      ref={ref}
    >
      <Flex w="100%" justify="space-between">
        <Box>
          {subtitle && (
            <Text fontSize="sm" color="gray.500" mb={2}>
              {subtitle}
            </Text>
          )}
          <Text>{title}</Text>
        </Box>
      </Flex>
    </ListItem>
  );
});
